import { createFileRoute, Outlet } from '@tanstack/react-router'

import { HeaderBar } from '@/components/header-bar'

export const Route = createFileRoute('/_index')({
  component: () => (
    <div className="bg-grid-subtle min-h-screen bg-background">
      <HeaderBar />
      <main className="container mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  ),
})
